import React from 'react';
import { motion } from 'framer-motion';
import { useOrder } from '../lib/orderContext';
import { trackAddToCartAndRedirect } from '../lib/metaPixel';
export function ValueSummary() {
  const {
    total,
    formattedTotal,
    checkoutUrl
  } = useOrder();
  const goToCheckout = () => {
    trackAddToCartAndRedirect(checkoutUrl, {
      content_name: 'El Protocolo Meno-Metabólico + 3 Bonos',
      content_ids: ['42499535011925'],
      content_type: 'product',
      value: total,
      currency: 'USD'
    });
  };
  return <section className="py-12 md:py-16 bg-[#faf6ee]" data-id="element-239">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8
      }} className="bg-[#2d4a3e] rounded-2xl shadow-2xl px-5 py-8 sm:p-8 md:p-12 text-center relative overflow-hidden" data-id="element-241">
          {/* Subtle background texture/gradient effect */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" data-id="element-242"></div>

          <h2 className="font-serif text-3xl md:text-4xl text-white mb-8 relative z-10" data-id="element-243">
            Lo que obtienes hoy:
          </h2>

          <ul className="text-left space-y-4 mb-8 text-white/90 text-base sm:text-lg md:text-xl w-fit mx-auto relative z-10" data-id="element-244">
            <li className="flex items-start gap-3" data-id="element-245">
              <span className="text-[#c9a961] flex-shrink-0" data-id="element-246">✦</span>
              <span data-id="element-247">Protocolo Meno-Metabólico — $37 USD</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-248">
              <span className="text-[#c9a961] flex-shrink-0" data-id="element-249">✦</span>
              <span data-id="element-250">Bono 1: Menús Express — $27 USD</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-251">
              <span className="text-[#c9a961] flex-shrink-0" data-id="element-252">✦</span>
              <span data-id="element-253">Bono 2: Checklist Nocturna — $27 USD</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-254">
              <span className="text-[#c9a961] flex-shrink-0" data-id="element-255">✦</span>
              <span data-id="element-256">Bono 3: Guía de Desayunos — $27 USD</span>
            </li>
          </ul>

          <div className="w-24 h-px bg-[#c9a961]/50 mx-auto mb-8 relative z-10" data-id="element-257"></div>

          <div className="mb-8 relative z-10" data-id="element-258">
            <p className="text-[#a8a8a8] line-through text-lg mb-2" data-id="element-259">
              Valor total real: $118 USD
            </p>
            <p className="text-white text-xl mb-2" data-id="element-260">Hoy lo llevas por solo:</p>
            <motion.div key={formattedTotal} initial={{
            scale: 0.9,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} className="font-serif text-5xl md:text-6xl font-bold text-[#c9a961]" data-id="element-261">
              {formattedTotal}
            </motion.div>
          </div>

          <motion.button onClick={goToCheckout} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-[#c9a961] text-[#1f3a2e] px-8 py-5 rounded-lg text-lg md:text-xl font-bold shadow-xl hover:bg-[#b8954d] transition-colors relative z-10" data-id="element-262">
            Sí, Quiero Todo Por {formattedTotal}
          </motion.button>

          <p className="mt-4 text-sm text-[#a8a8a8] relative z-10" data-id="element-263">
            Pago único · Descarga inmediata
          </p>
        </motion.div>
      </div>
    </section>;
}